module.exports = __webpack_public_path__ + "static/media/ribbon_notif.f4ec7587.svg";